import moment from "moment";
import React from "react";
import { Table, Row, Alert } from "react-bootstrap";

export const ListReviewCuts = ({ reviewCuts, hideColumns = {} }) => {
  return (
    <>
      <Row md={4} className="ml-1">
        <Alert
          variant="primary"
          className="text-center mt-4"
          style={{ fontSize: "13px" }}
        >
          Estados de Cuenta
        </Alert>
      </Row>

      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th hidden={hideColumns.caseType}>Tipo de Trámite / Movimiento</th>
            <th hidden={hideColumns.typeInvoice}>Tipo de folio ATC</th>
            <th hidden={hideColumns.invoiceATC}>Folio ATC</th>
            <th hidden={hideColumns.createdAt}>Fecha Hora (DD/MM/AAAA HH:MM:SS)</th>
            <th hidden={hideColumns.user}>Usuario</th>
          </tr>
        </thead>
        <tbody>
          {reviewCuts?.map( (reviewCut, idx) => (
            <tr key={idx}>
              <td hidden={hideColumns.caseType}>{reviewCut.caseType}</td>
              <td hidden={hideColumns.typeInvoice}>{reviewCut.typeInvoice}</td>
              <td hidden={hideColumns.invoiceATC}>{reviewCut.invoiceATC}</td>
              <td hidden={hideColumns.createdAt}>{moment(reviewCut.createdAt).format("DD/MM/Y HH:mm:ss A")}</td>
              <td hidden={hideColumns.user}>{reviewCut.userFullName}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};
